import React, { useState } from 'react';

export const renderFormattedText = (text) => {
  if (!text) return null;
  return text.split('\n').map((line, i, arr) => {
    // Split by bold **...** and italic _..._
    const parts = line.split(/(\*\*[^*]+\*\*|_[^_]+_)/g);
    return (
      <React.Fragment key={`line-${i}-${line.slice(0,10)}`}>
        {parts.map((part, j) => {
          const partKey = `${i}-${j}-${part.slice(0,8)}`;
          if (part.startsWith('**') && part.endsWith('**')) {
            return <strong key={partKey}>{part.slice(2, -2)}</strong>;
          }
          if (part.startsWith('_') && part.endsWith('_') && part.length > 2) {
            return <em key={partKey}>{part.slice(1, -1)}</em>;
          }
          return <React.Fragment key={partKey}>{part}</React.Fragment>;
        })}
        {i < arr.length - 1 && <br />}
      </React.Fragment>
    );
  });
};

export const TruncatedText = ({ text, className }) => {
  const [expanded, setExpanded] = useState(false);
  if (!text) return null;
  if (!text.includes('$')) return <span className={className}>{renderFormattedText(text)}</span>;
  const parts = text.split('$');
  const before = parts[0];
  const after = parts.slice(1).join('');
  if (expanded) {
    return (
      <span className={className}>
        {renderFormattedText(before + after)}{' '}
        <span onClick={(e) => { e.stopPropagation(); setExpanded(false); }} className="text-[#8B6914] text-[10px] font-medium hover:underline ml-0.5 cursor-pointer" role="button" tabIndex={0}>voir moins</span>
      </span>
    );
  }
  return (
    <span className={className}>
      {renderFormattedText(before)}
      <span onClick={(e) => { e.stopPropagation(); setExpanded(true); }} className="text-[#8B6914] text-[10px] font-medium hover:underline ml-0.5 cursor-pointer" role="button" tabIndex={0}>...voir plus</span>
    </span>
  );
};
